import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material';

import ListItemButton from '@mui/material/ListItemButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { SelectableItemT } from '../hooks/sideMenuSections';

const SideMenuItem = ({
    activeSectionTitle,
    item,
    setActiveSectionTitle,
}: {
    activeSectionTitle: string;
    item: SelectableItemT;
    setActiveSectionTitle: (arg: string) => void;
}): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Tooltip
            title={item.tooltipMessage && t(item.tooltipMessage)}
            key={item.title}
        >
            <span>
                <ListItemButton
                    disabled={item.disabled}
                    onClick={() => setActiveSectionTitle(item.title)}
                    selected={activeSectionTitle === item.title}
                    sx={{ paddingLeft: theme.spacing(1) }}
                >
                    <Typography variant="body1">{item.title}</Typography>
                </ListItemButton>
            </span>
        </Tooltip>
    );
};

export default SideMenuItem;
